import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-delete\"><path fill=\"#8d92a1\" d=\"M216.127386 857.184717c0 54.490032 44.134173 98.624205 98.624205 98.624205l394.496819 0c54.490032 0 98.624205-44.134173 98.624205-98.624205L807.872614 265.439488 216.127386 265.439488 216.127386 857.184717zM857.184717 117.503181 684.591847 117.503181l-49.312102-49.312102L388.719232 68.191078l-49.312102 49.312102L166.815283 117.503181l0 98.624205 690.369434 0L857.184717 117.503181z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/delete.svg
// module id = Imjp
// module chunks = 57